import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import he from "he";
import "../Products/ProductDropdown";
import { useSelector } from "react-redux";
import "./ServiceDropdown.css";

const ServiceDrawer = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const drawerRef = useRef(null);
  const [serviceMenu, setServiceMenu] = useState([]);
  const { services } = useSelector((state) => state.data);

  // Function to decode HTML entities
  const decodeHTML = (html) => (html ? he.decode(html) : "");

  // Function to capitalize only the first letter
  const capitalizeFirstLetter = (str) => {
    if (!str) return ""; // Prevents error when str is undefined or null
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  useEffect(() => {
    if (Array.isArray(services)) {
      setServiceMenu(services);
    }
  }, [services]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleServiceClick = (service) => {
    const encodedTitle = encodeURIComponent(service?.title?.toLowerCase().replace(/\s+/g, "-"));
    navigate(`/service-description/${encodedTitle}`, { state: { service } });
    onClose();
  };
  return (
    <div className="best-dropdown2">
      <div className={`service-drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-content-service" ref={drawerRef}>
          <button className="close-btn" onClick={onClose}>✖</button>

          {serviceMenu.length > 0 ? (
            <ul className="serviceDropdown">
              {serviceMenu.map((service) => (
                <li className="serv-list" key={service?._id} onClick={() => handleServiceClick(service)}>
                  {service?.title.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
                
                </li>
              ))}
            </ul>
          ) : (
            <p className="loading-message">Loading services...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceDrawer;